function openCart() {
  fetch('/?sections=cart-drawer')
    .then(r => r.json())
    .then(data => {
      if (data['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('.drawer__inner');
        const currentInner = document.querySelector('#CartDrawer .drawer__inner');
        if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
        const newCartDrawer = doc.querySelector('cart-drawer');
        const currentCartDrawer = document.querySelector('cart-drawer');
        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.classList.toggle('is-empty', newCartDrawer.classList.contains('is-empty'));
        }
        const newItems = doc.querySelector('cart-drawer-items');
        const currentItems = document.querySelector('cart-drawer-items');
        if (newItems && currentItems) {
          currentItems.classList.toggle('is-empty', newItems.classList.contains('is-empty'));
        }
      }
      setTimeout(function() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.open();
      }, 100);
    })
    .catch(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.open();
    });
}

$(document).ready(function () {

  function maybeAddBonusBottle(callback) {
    var $bonusEl = $(".bdp_sub_bonus_bottle");
    if ($bonusEl.length) {
      var bonusVariantId = $bonusEl.attr("data-variant-id");
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: [{ id: bonusVariantId, quantity: 1 }] },
        dataType: "json",
        success: function () { callback(); },
        error: function () { callback(); }
      });
    } else {
      callback();
    }
  }

  $(".bdtr_containaer_out").addClass("loaded");

  if ($(".bdru_carousel").length) {
    $(".bdru_carousel").slick({
      dots: false,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "80px",
      responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: "30px" } }],
    });
  }

  if ($(".bd_aths_cont:not(.slick-progress)").length) {
    $(".bd_aths_cont:not(.slick-progress)").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: true, dots: true, centerPadding: "30px" } }],
    });
  }

  if ($(".bdrs_carousel").length) {
    $(".bdrs_carousel").slick({
      dots: false,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_11.png?v=1724852466'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_12.png?v=1724852466'/></button>",
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "80px",
      responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: "30px" } }],
    });
  }

  if ($(".bdrs_carousel_upd").length) {
    $(".bdrs_carousel_upd").slick({
      dots: true,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "80px",
      responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: "30px" } }],
    });
  }

  if ($(".bdp_gallery_main").length) {
    $(".bdp_gallery_main").slick({
      dots: false,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".bdp_gallery_thumb",
      cssEase: "linear",
    });
  }

  if ($(".bdp_gallery_thumb").length) {
    $(".bdp_gallery_thumb").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".bdp_gallery_main",
      cssEase: "linear",
      focusOnSelect: true,
    });
  }

  if ($(".bdtr_review_carousle").length) {
    $(".bdtr_review_carousle").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  if ($(".qz_results_insideCar").length) {
    $(".qz_results_insideCar").slick({
      dots: false,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
      infinite: true,
      slidesToShow: 1,
    });
  }

  $(".bdp_sub_form_inn_header").click(function () {
    $(this).closest('.bdp_form').find(".bdp_sub_form").removeClass("active");
    $(this).closest(".bdp_sub_form").addClass("active");
    $(this).closest(".bdp_sub_form_inner").find(".bdp_quantity_selector.first_load_selected").trigger("click");
  });

  $(".bdp_exp_box").click(function () {
    $(this).find(".bdp_exp_info").slideToggle();
  });

  $(".bdp_sub_ann").click(function () {
    $(this).closest(".bdp_sub_form").find(".bdp_sub_form_inn_header").trigger("click");
  });

  $(".bdp_quantity_selector").click(function () {
    $(this).closest('.bdp_form').find(".bdp_quantity_selector").removeClass("active");
    $(this).addClass("active");
    var currentPrice = $(this).attr("data-price");
    var comparePrice = $(this).attr("data-compare-price");
    $(".Onetime_pricing s").html(comparePrice);
    $(".Onetime_pricing p").html(currentPrice);
  });

  $(".sa_pp_variant").click(function () {
    $(".sa_pp_variant").removeClass("active");
    $(this).addClass("active");
    var currentId = $(".sa_pp_variant.active").attr("data-id");
    $(".sa_btn_price").hide();
    $('.sa_btn_price[data-id="' + currentId + '"]').show();
  });

  if ($(".bdp_container").length) {
    $(".bd_primary_btn").click(function (evt) {
      evt.preventDefault();
      $("html, body").animate({ scrollTop: $(".bdp_container").offset().top - 100 }, 500);
    });
  }

  if ($(".qz_summary").length) {
    $(".slideToSummary").click(function (evt) {
      evt.preventDefault();
      $("html, body").animate({ scrollTop: $(".qz_summary").offset().top - 100 }, 500);
    });
  }

  $(".bdru_video_out").mouseover(function () { $(this).addClass("hovered"); });
  $(".bdru_video_out").mouseleave(function () { $(this).removeClass("hovered"); });

  $(".bdtim_accord").click(function () {
    $(this).find(".dbtim_accord_info").slideToggle();
  });

  $(".bdru_video_out").click(function () {
    var clickedVideo = $(this).find("video")[0];
    $(".bdru_video_out").each(function () {
      var video = $(this).find("video")[0];
      if (video && video !== clickedVideo && !video.paused) {
        video.pause();
        $(this).find(".bdru_Control_pause").hide();
        $(this).find(".bdru_Control_play").show();
      }
    });
    if (clickedVideo) {
      if (clickedVideo.paused) {
        clickedVideo.play();
        $(this).find(".bdru_Control_pause").show();
        $(this).find(".bdru_Control_play").hide();
      } else {
        clickedVideo.pause();
        $(this).find(".bdru_Control_pause").hide();
        $(this).find(".bdru_Control_play").show();
      }
    }
  });

  $(".bdm_qty_plus").click(function () {
    var currentVal = parseFloat($(".bdm_qty_val").html());
    currentVal++;
    $(".bdm_qty_val").html(currentVal);
    calculatePrice();
  });

  $(".bdm_qty_min").click(function () {
    var currentVal = parseFloat($(".bdm_qty_val").html());
    if (currentVal > 1) { currentVal--; }
    $(".bdm_qty_val").html(currentVal);
    calculatePrice();
  });

  function calculatePrice() {
    var currentPrice = $(".bdm_qty_val").attr("data-price");
    var currentQty = parseFloat($(".bdm_qty_val").html());
    currentPrice = currentPrice * currentQty;
    currentPrice = (currentPrice / 100).toFixed(2);
    currentPrice = "$" + currentPrice;
    $(".bdo_total_price__js").html(currentPrice);
    $(".bdo_qty_info__js").html(currentQty + (currentQty == 1 ? " Jar" : " Jars"));
  }

  if ($(".lazyVideo").length) {
    setTimeout(function () {
      $(".lazyVideo").each(function () {
        var video = $(this)[0];
        video.play();
        setTimeout(function () { video.pause(); }, 200);
      });
    }, 500);
  }

  $(".qz_pr_upd_cell").click(function () {
    $(this).closest(".bdp_sub_form_inner").find(".qz_pr_upd_cell").removeClass("active");
    $(this).addClass("active");
    var variantId = $(this).attr("data-id");
    $(this).closest(".bdp_sub_form_inner").find(".bdp_price_cont_outer").hide();
    $(this).closest(".bdp_sub_form_inner").find('.bdp_price_cont_outer[data-id="' + variantId + '"]').show();
  });

  $('.bdp_atc_simple').click(function (evt) {
    evt.preventDefault();
    var currentId = $(this).attr('data-id');
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: [{ id: currentId, quantity: 1 }] },
      dataType: "json",
      success: function () { fbq('track', 'AddToCart'); openCart(); },
      error: function () { alert("Error adding item to the cart."); },
    });
  });

  $(".bdp_atc_quiz").click(function (evt) {
    evt.preventDefault();

    var buttonQuantity = $(".bdp_atc_quiz").attr("data-button");
    var productType = $(this).attr("data");
    var mode = $(this).closest(".bdp_form").find(".bdp_sub_form.active").attr("data-mode");

    if (buttonQuantity == "oneBottle") {
      var currentId = $(".bdp_sub_form.active").attr("data-id");
    } else {
      var currentId = $(this).closest(".bdp_form").find(".bdp_quantity_selector.active").attr("data-id");
    }

    var currentQtyIndex = parseFloat($(this).closest(".bdp_form").find(".bdp_quantity_selector.active").attr("data-qty"));
    var currentQty = 1;
    var currentIdSub = $(this).closest(".bdp_form").find(".bdp_sub_form.active").attr("data-id");

    if (mode == "onetime") {
      var currentPopup = $(this).attr("data-popup");

      if (currentPopup == "pmo") {
        jQuery.getJSON("/cart.js", function (cart) {
          var hasRestrictedItem = cart.items.some(function (item) {
            return item.id === 45193441378481 || item.id === 44652185092273;
          });
          if (hasRestrictedItem) {
            jQuery.ajax({
              type: "POST", url: "/cart/add.js",
              data: { items: [{ id: currentId, quantity: 1 }] },
              dataType: "json",
              success: function () { fbq('track', 'AddToCart'); maybeAddBonusBottle(function () { openCart(); }); },
              error: function () { alert("Error adding item to the cart."); },
            });
          } else {
            $(".pmo_outer").css("display", "flex");
            $(".pmo_outer").find(".pmo_accept").attr("data-id", currentId);
            $(".pmo_outer").find(".pmo_decline").attr("data-id", currentId);
          }
        });
      } else {
        jQuery.ajax({
          type: "POST", url: "/cart/add.js",
          data: { items: [{ id: currentId, quantity: 1 }] },
          dataType: "json",
          success: function () { fbq('track', 'AddToCart'); maybeAddBonusBottle(function () { openCart(); }); },
          error: function () { alert("Error adding item to the cart."); },
        });
      }

    } else {
      jQuery.ajax({
        type: "POST", url: "/cart/clear.js", dataType: "json",
        success: function () {
          var selling_plan = $(".bdp_atc_quiz").attr("data-selling-plan");
          jQuery.getJSON("/cart.js", function () {
            jQuery.ajax({
              type: "POST", url: "/cart/add.js",
              data: { id: currentIdSub, quantity: currentQty, selling_plan: selling_plan },
              dataType: "json",
              success: function () { fbq('track', 'AddToCart'); maybeAddBonusBottle(function () { openCart(); }); },
              error: function () { alert("Error adding the subscription item to the cart."); },
            });
          });
        },
        error: function () { alert("Error clearing the cart."); },
      });
    }
  });

  $(".pmo_decline").click(function () {
    var currentId = $(this).attr("data-id");
    jQuery.ajax({
      type: "POST", url: "/cart/add.js",
      data: { items: [{ id: currentId, quantity: 1 }] },
      dataType: "json",
      success: function () { fbq('track', 'AddToCart'); maybeAddBonusBottle(function () { openCart(); $(".pmo_outer").hide(); }); },
      error: function () { alert("Error adding the subscription item to the cart."); },
    });
  });

  $(".pmo_accept").click(function () {
    var currentId = $(this).attr("data-id");
    var items = [{ id: currentId, quantity: 1 }];
    $(".pmo_product_card").each(function () {
      var $toggle = $(this).find('.pmo_switch input[type="checkbox"]');
      if ($toggle.is(":checked")) items.push({ id: $toggle.data("product-id"), quantity: 1 });
    });
    jQuery.ajax({
      type: "POST", url: "/cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function () { fbq('track', 'AddToCart'); maybeAddBonusBottle(function () { openCart(); $(".pmo_outer").hide(); }); },
      error: function () { alert("Error adding the subscription item to the cart."); },
    });
  });

  $(document).scroll(function () {
    if ($(document).scrollTop() >= 600) {
      $(".sa_whole").addClass("active");
    } else {
      $(".sa_whole").removeClass("active");
    }
  });

});
